<div class="step" [attr.data-parentid]="step?.sys?.id || ''">
  <!-- Título del paso -->
  <h2 id="steptitle" class="step-title" [@fadeInOut] [innerHTML]="step?.fields?.steptitle | interpolate: getInterpolationData()"></h2>
  <h2 id="stepSubTitle" class="step-subtitle" [@fadeInOut] [innerHTML]="step?.fields?.stepSubTitle | interpolate: getInterpolationData()"></h2>
  <!-- <span *ngIf="step?.fields?.stepSubTitle" >*</span> -->
  <!-- Renderizar según el tipo de paso -->
  <div [ngSwitch]="step?.fields?.stepType">    
    <!-- Step: Campos numéricos -->
    <div *ngSwitchCase="'number_input'" class="input-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
        <label>{{ field.label  }}</label>
        <input  
          [type]="getInputType(field.validations)"
          [(ngModel)]="formData[field.key]"
          (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
          [placeholder]="field.placeholder"
          [name]="field.key"
          [attr.data-id]="field.key"
          [required]="field.validations?.required"
          [min]="field.validations?.min"
          [max]="field.validations?.max"
          #inputField="ngModel">
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
            <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
            <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
            <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
          </div>          
      </div>
    </div>
    <!-- Step: Zip Code  -->
    <div *ngSwitchCase="'zip_code'" class="input-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
        <input class="zipcode-text"
          [type]="getInputType(field.validations)"
          [(ngModel)]="formData[field.key]"
          (ngModelChange)="zipCodeValidator(formData[field.key], inputField); dataChanged.emit()"
          (change)="validateZipCode($event, field.key, inputField)"
          [placeholder]="field.placeholder"
          [name]="field.key"
          [attr.data-id]="field.key"
          (keypress)="onlyNumbers($event)"
          [required]="field.validations?.required"
          maxlength="5"
          #inputField="ngModel">
          <!-- <div *ngIf="formData[field.key] != '' || (!(inputField.errors?.['required']) && !(inputField.errors?.['invalidLength']) && !(inputField.errors?.['invalidNotFound']))" class="city-state-text"> -->
          <div *ngIf="(formData[field.key] != '') && (city != null && state != null) && (!(inputField.errors?.['invalidLength']) || !(inputField.errors?.['invalidNotFound']))" class="city-state-text">
            <div>{{ city }}, {{ state }}</div>            
          </div>                            
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)" class="error-messages">
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">
              {{ field.label }} is required
            </small>
            <small class="error-required-label" *ngIf="!(inputField.errors?.['required']) && (inputField.errors?.['invalidLength'] || inputField.errors?.['invalidNotFound'])" >
              {{ field.label }} is invalid.
            </small>
          </div>   
          <div *ngIf="!(inputField.invalid && (inputField.dirty || inputField.touched)) && (formData[field.key] != '') && (city == null && state == null)" class="error-messages">
            <small class="error-required-label">
               {{ field.label }} is invalid.
            </small>
          </div>              
      </div>
    </div>    
    <!-- Step: Checkboxes --> 
    <div *ngSwitchCase="'checkbox_options'" class="checkbox-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
        <label class="field-label">{{ field.label }}</label>
        <div [id]="field.key">
          <div *ngFor="let option of field.options" class="checkbox_options">
            <input 
              [id]="option.value"
              type="checkbox"
              [value]="option.value"
              [checked]="formData[field.key]?.includes(option.value)"
              (change)="onCheckboxChange(field.key, option.value, $event)"
              [name]="option.value"
            >
            <label [for]="option.value">{{ option.label }}</label>
          </div>
        </div>
      </div>
    </div>    
    <!-- Step: Dropdown -->
    <div *ngSwitchCase="'dropdown'" class="dropdown-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields" class="slider-container">
          <label *ngIf="field.label" [innerHTML]="field.label | interpolate: getInterpolationData()" >{{ field.label }}</label>  
          <div *ngIf="field.toolTip" class="tooltip-container" [innerHTML]="field.toolTip | interpolate: getInterpolationData()"></div> 
          <app-search-dropdown
              [(ngModel)]="formData[field.key]"
              (ngModelChange)="onFieldModelChange(field, formData[field.key])"
              [attr.data-id]="field.key"
              [placeholder]="field.placeholder"  
              [defaultValue]="formData[field.key]"
              [fileUrl]="field.optionsFileAssetURL"
              [rootKey]="field.settings?.rootKey"
              [displayKey]="field.settings?.displayKey"
              [filterKeys]="field.settings?.filterKeys"
              [filterValues]="formData"
            ></app-search-dropdown>
      </div>
    </div>
    <!-- Step: Slider Range -->
    <div *ngSwitchCase="'slider_input'" class="slider-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields" class="slider-container">
        <!-- <label>{{ field.label }}</label>   -->
        <label *ngIf="field.label" [innerHTML]="field.label | interpolate: getInterpolationData()" >{{ field.label }}</label>  
        <div *ngIf="field.toolTip" class="tooltip-container" [innerHTML]="field.toolTip | interpolate: getInterpolationData()"></div> 
        <input 
          (pointerdown)="onSliderTouched(field)" 
          [id]="field.key" 
          class="custom_salider" 
          type="range" 
          [(ngModel)]="formData[field.key]" 
          (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])" 
          (change)="onSliderInteraction(field.key, formData[field.key])"
          [required]="field.validations?.required" 
          [name]="field.key" 
          [attr.data-id]="field.key" 
          [min]="field.validations?.min" 
          [max]="getSliderMax(field)" 
          [step]="field.sliderStep"
          #inputField="ngModel">         
            <div class="appearance-container">
              <div class="appearance-range" *ngIf="field.settings?.appearance == 'range'">
                <div *ngIf="this.step.fields.stepValueType == 'currency'">
                  <div *ngIf="field.validations?.plusvalue">
                    <div *ngIf="formData[field.key] < field.validations?.max">
                      <label for="" class="label-question">{{ (formData[field.key] - 10000) | currency:'USD':'symbol':'1.0-0'  }} - {{ (formData[field.key] + 10000) | currency:'USD':'symbol':'1.0-0'  }}</label>
                    </div>
                    <div *ngIf="formData[field.key] == field.validations?.max">
                      <label for="" class="label-question">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0') + "+"   }}</label>
                    </div>
                  </div>
                  <div *ngIf="!field.validations?.plusvalue">
                    <div *ngIf="formData[field.key] == 0">
                      <label for="" class="label-question">{{ (formData[field.key]) | currency:'USD':'symbol':'1.0-0' }}</label>
                    </div>
                    <div *ngIf="formData[field.key] != 0">
                      <label for="" class="label-question">{{ (formData[field.key] - 10000) | currency:'USD':'symbol':'1.0-0'  }} - {{ (formData[field.key] + 10000) | currency:'USD':'symbol':'1.0-0' }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="this.step.fields.stepValueType == 'percentage'">
                  <div *ngIf="field.validations?.minusvalue">
                    <div *ngIf="formData[field.key] == field.validations?.min">
                      <label for="" class="label-question">{{ (formData[field.key] + 1 ) + "% or Lower" }}</label>                
                    </div>
                  </div>              
                  <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
                    <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                  </div>
                  <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
                    <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                      <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                    </div>
                  </div> 
                  <div *ngIf="field.validations?.plusvalue">
                    <!-- <div *ngIf="(formData[field.key] < field.validations?.max) && !(formData[field.key] == field.validations?.min)">
                      <label for="">{{ (formData[field.key] | number: '1.2-2' ) + "%" }}</label>
                    </div> -->
                    <div *ngIf="formData[field.key] == field.validations?.max">
                      <label for="" class="label-question">{{ "Over " + (formData[field.key] - 1 ) + "%" }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
                  <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
                  <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
                  <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
                </div>  
              </div>
              <div *ngIf="field.settings?.appearance != 'range'">
                <div *ngIf="this.step.fields.stepValueType == 'currency'">
                  <div *ngIf="field.validations?.plusvalue">
                    <div *ngIf="formData[field.key] < field.validations?.max">
                      <!-- <label for="" class="label-question">{{ formData[field.key] | currency:'USD' : 'symbol' : '1.0-0'  }}</label> -->
                      <label for="" class="label-question">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0'  }}</label>
                    </div>
                    <div *ngIf="formData[field.key] == field.validations?.max">
                      <label for="" class="label-question">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0') + "+"   }}</label>
                    </div>
                  </div>
                  <div *ngIf="!field.validations?.plusvalue">
                    <label for="" class="label-question">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0' }}</label>
                  </div>
                </div>
                <div *ngIf="this.step.fields.stepValueType == 'percentage'">
                  <div *ngIf="field.validations?.minusvalue">
                    <div *ngIf="formData[field.key] == field.validations?.min">
                      <label for="" class="label-question">{{ (formData[field.key] + 1 ) + "% or Lower" }}</label>                
                    </div>
                  </div>              
                  <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
                    <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                  </div>
                  <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
                    <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                      <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                    </div>
                  </div> 
                  <div *ngIf="field.validations?.plusvalue">
                    <!-- <div *ngIf="(formData[field.key] < field.validations?.max) && !(formData[field.key] == field.validations?.min)">
                      <label for="">{{ (formData[field.key] | number: '1.2-2' ) + "%" }}</label>
                    </div> -->
                    <div *ngIf="formData[field.key] == field.validations?.max">
                      <label for="" class="label-question">{{ "Over " + (formData[field.key] - 1 ) + "%" }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
                  <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
                  <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
                  <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
                </div>  
              </div>
            </div>


        
      </div>
    </div> 
    <!-- Step: Single Option -->
    <!-- Telemetry: option click can auto-advance to next step. -->
    <div *ngSwitchCase="'single_option'" class="single-option-group">
      <div class="card-select-container">
        <div *ngFor="let field of step?.fields?.configuration?.fields" class="card-grid" [id] ="field.key">
          
          <div *ngFor="let option of field.options" class="property-card"     
                [ngClass]="{'selected' : formData[field.key] == option.value }" 
                [id]="option.value" 
                [attr.data-id]="field.key"
                (click)="selectOptionDynamic(field.key, option, $event, field.selectAction);">            
            <!-- <span>{{ option.label }}</span> -->
             <div  [innerHTML]="option.label"></div>
             <!-- <div [innerHTML]=""></div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Step: Single Option Icon -->
    <div *ngSwitchCase="'single_option_icon'" class="single-option-icon-group">                 
      <div class="card-select-container">
        <div *ngFor="let field of step?.fields?.configuration?.fields" class="card-grid" [id] ="field.key">
          <label *ngIf="field.label">{{ field.label }}</label>
          <div class="cards-container">
            <div *ngFor="let option of field.options" class="property-card" 
                [ngClass]="{'selected' : formData[field.key] == option.value }" 
                [id]="option.value" 
                [attr.data-id]="field.key"
                (click)="selectOptionDynamic(field.key, option, $event, field.selectAction)">            

                <i class="fa-solid" *ngIf="option.icon" [ngClass]="option.icon" aria-hidden="true"></i>
                <img class="image-option" *ngIf="option.assetID" [src]="option.safeUrl">
                <span>{{ option.label }}</span>
                
            </div>
          </div>
        </div>
      </div>
    </div>    
    <!-- Step: Two Step Conditional -->    
    <div *ngSwitchCase="'single_option_conditional'" class="single-option-group">
      <div class="">
        <div *ngFor="let field of step?.fields?.configuration?.fields">
          <div *ngIf="field.conditional != true" class="card-select-container">
            <div *ngFor="let option of field.options" 
            class="property-card" 
            [id]="option.value"
            [attr.data-id]="field.key"
            [ngClass]="{'selected' : formData[field.key] == option.value }"
            (click)="validateConditionalField(field.key, option, $event, step?.fields?.configuration?.fields)" 
            >            
              <span>{{ option.label }}</span>
            </div>
          </div>
          <!-- <div *ngIf="field.conditional == true && (field.conditionalFieldValidator == true) || formData[field.conditionalFieldKey] == field.conditionalValue">                    -->
            <div *ngIf="field.conditional == true && formData[field.conditionalFieldKey] == field.conditionalValue">                   
            <div class="step-title-conditional">{{field.fieldTitle}}</div>     
            <div class="step-subtitle-conditional">{{field.fieldSubtitle}}</div>     
            <div class="next-step">
              <div [ngSwitch]="field.fieldType">
                <div *ngSwitchCase="'dropdown'"><div>
                  <select                     
                    [id]="field.key"
                    [(ngModel)]="formData[field.key]"
                    (ngModelChange)="onFieldModelChange(field, formData[field.key])"
                    [name]="field.key"
                    [attr.data-id]="field.key"
                    [required]="field.validations?.required"                    
                    >
                    <!-- (ngModelChange)="dataChanged.emit()" -->
                    <option [ngValue]="null" disabled>Please Select...</option>
                    <option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option>
                  </select>
                </div>
              </div>
            </div>
            </div>  
          </div>
        </div>
      </div>

    </div>    
    <!-- Step: Address  -->
    <div *ngSwitchCase="'address'" class="input-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
        <input class="zipcode-text"
          [type]="getInputType(field.validations)"
          [(ngModel)]="formData[field.key]"
          (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
          [placeholder]="field.placeholder"
          [name]="field.key"
          [attr.data-id]="field.key"
          [required]="field.validations?.required"
          [min]="field.validations?.min"
          [max]="field.validations?.max"
           (keydown.enter)="false"
          #inputField="ngModel">
          <div>
          </div>
      </div> 
    </div>   
    <!-- Step: Address Image  -->    
    <div *ngSwitchCase="'address_image'" class="input-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
      <div *ngIf="houseImageUrl" class="house-image-container">
        <img [src]="houseImageUrl" alt="Home Image" class="house-image">
      </div>
      <div *ngIf="!houseImageUrl" class="house-image-container">
        <img src="../../../assets/images/default-1.jpg" alt="Default Home Image" class="house-image">
      </div>
        <div class="input-container">
        <input class="address-image-input"
              #addressInput
              [type]="getInputType(field.validations)"
              [(ngModel)]="formData[field.key]"
          (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
              [placeholder]="field.placeholder"
              [name]="field.key"
              [attr.data-id]="field.key"
              [required]="field.validations?.required"
              (keydown.enter)="false"
              placeholder="Enter you address">
      </div>
      <span class="address-image-bottom-text">Takes About 60 Seconds!</span>
      </div>
    </div>
    <!-- Step: Address   -->    
    <div *ngSwitchCase="'address_full_info_v1'" class="input-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields" [ngClass]="{'form-item-med' : field.settings.inputSize == 'Medium', 'form-item-large' : field.settings.inputSize == 'Large'}">
        <div *ngIf="field.key == 'Address'" >
          <div class="input-container">
          <span *ngIf="field.label" class="input-label"> {{field.label}} </span>
          <input class="address-image-input"
                #addressInput
                [type]="getInputType(field.validations)"
                [(ngModel)]="formData[field.key]"
                (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
                [placeholder]="field.placeholder"
                [name]="field.key"
                [attr.data-id]="field.key"
                [required]="field.validations?.required"
                (keydown.enter)="false"
                placeholder="Enter you address">
          </div>
        </div>
        <div *ngIf="field.key != 'Address'" >
          <div class="input-container">
            <span *ngIf="field.label"> {{field.label}} </span>
            <input class="address-image-input"                
                    [type]="getInputType(field.validations)"
                    [(ngModel)]="formData[field.key]"
                    (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
                    [placeholder]="field.placeholder"
                    [name]="field.key"
                    [attr.data-id]="field.key"
                    [required]="field.validations?.required"
                    placeholder="">
          </div>
        </div>        
      </div>
    </div>              
    <!-- Step: Slider Conditional -->
    <div *ngSwitchCase="'slider_conditional'" class="slider-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields">
        <div *ngIf="field.conditional != true">
          <label>{{ field.label }}</label>
          <div *ngIf="field.toolTip" class="tooltip-container" [innerHTML]="field.toolTip"></div> 
          <input 
              [id]="field.key"
              class="custom_salider"
              type="range" 
              [(ngModel)]="formData[field.key]" 
              (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
              (change)="onSliderInteraction(field.key, formData[field.key])"
              [required]="field.validations?.required"
              [name]="field.key"  
              [attr.data-id]="field.key"
              [min]="field.validations?.min"
              [max]="field.validations?.max" 
              [step]="field.sliderStep"
              #inputField="ngModel">
              <!-- Label Valitation -->
              <div *ngIf="step.fields.stepValueType == 'currency'">
                <div *ngIf="field.validations?.plusvalue">
                  <div *ngIf="formData[field.key] < field.validations?.max">
                    <label for="">{{ formData[field.key] |currency:'USD':'symbol':'1.0-0'  }}</label>
                  </div>
                  <div *ngIf="formData[field.key] == field.validations?.max">
                    <label for="">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0' ) + "+"   }}</label>
                  </div>
                </div>
                <div *ngIf="!field.validations?.plusvalue">
                  <label for="">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0'  }}</label>
                </div>
              </div>
              <div *ngIf="step.fields.stepValueType == 'percentage'">
                <div *ngIf="field.validations?.minusvalue">
                  <div *ngIf="formData[field.key] == field.validations?.min">
                    <label for="">{{ (formData[field.key] + 1 ) + "% or Lower" }}</label>                
                  </div>
                </div>              
                <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
                  <label for="">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                </div>
                <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
                  <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                    <label for="">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                  </div>
                </div> 
                <div *ngIf="field.validations?.plusvalue">
                  <!-- <div *ngIf="(formData[field.key] < field.validations?.max) && !(formData[field.key] == field.validations?.min)">
                    <label for="">{{ (formData[field.key] | number: '1.2-2' ) + "%" }}</label>
                  </div> -->
                  <div *ngIf="formData[field.key] == field.validations?.max">
                    <label for="">{{ "Over " + (formData[field.key] - 1 ) + "%" }}</label>
                  </div>
                </div>
              </div>
            <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
              <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
              <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
              <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
            </div>    
        </div >
        <div *ngIf="field.conditional == true ">
          <!-- {{ step.fields.stepValueType  }} -->
          <label>{{ field.label }}</label>       
          <div *ngIf="field.toolTip" class="tooltip-container" [innerHTML]="field.toolTip"></div> 
          <input 
              [id]="field.key"
              class="custom_salider"
              type="range" 
              [(ngModel)]="formData[field.key]" 
              (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
              (change)="dataChanged.emit(); onSliderInteraction(field.key, formData[field.key])"
              [required]="field.validations?.required"
              [name]="field.key"  
              [attr.data-id]="field.key"
              [min]="field.validations?.min"
              [max]="formData[field.conditionalFieldKey]" 
              [step]="field.sliderStep"              
              #inputField="ngModel">
          <!-- Label Valitation -->
          <div *ngIf="step.fields.stepValueType == 'currency'">
            <div *ngIf="field.validations?.plusvalue">
              <div *ngIf="formData[field.key] < field.validations?.max">
                <label for="">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0'  }}</label>
              </div>
              <div *ngIf="formData[field.key] == field.validations?.max">
                <label for="">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0' ) + "+"   }}</label>
              </div>
            </div>
            <div *ngIf="!field.validations?.plusvalue">
              <label for="">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0'  }}</label>
            </div>
          </div>
          <div *ngIf="step.fields.stepValueType == 'percentage'">
            <div *ngIf="field.validations?.minusvalue">
              <div *ngIf="formData[field.key] == field.validations?.min">
                <label for="">{{ (formData[field.key] + 1 ) + "% or Lower" }}</label>                
              </div>
            </div>              
            <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
              <label for="">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
            </div>
            <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
              <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                <label for="">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
              </div>
            </div> 
            <div *ngIf="field.validations?.plusvalue">
              <!-- <div *ngIf="(formData[field.key] < field.validations?.max) && !(formData[field.key] == field.validations?.min)">
                <label for="">{{ (formData[field.key] | number: '1.2-2' ) + "%" }}</label>
              </div> -->
              <div *ngIf="formData[field.key] == field.validations?.max">
                <label for="">{{ "Over " + (formData[field.key] - 1 ) + "%" }}</label>
              </div>
            </div>
          </div>
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
            <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
            <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
            <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
          </div>    
        </div>      
      </div>
    </div>    
    <!-- Step: Personal Data -->
    <div *ngSwitchCase="'personal_info'" class="contact-form">
      <div *ngFor="let field of step?.fields?.configuration?.fields">        
        <!-- Text Inputs -->     
        <div *ngIf="field.type === 'text_input' || field.type === 'email_input'" class="input-group">        
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">            
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">{{ field.label }} is required</small>
            <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
            <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
          </div>        
          <input 
            [placeholder]="field.label"
            [type]="field.type === 'email_input' ? 'email' : 'text'"
            [(ngModel)]="formData[field.key]"
            (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
            [name]="field.key"
            [required]="field.validations?.required"
            #inputField="ngModel"
          >
    
        </div>
        <!-- Phone Input con máscara -->
        <div *ngIf="field.type === 'phone_input'" class="input-group">
          <!-- <label>{{ field.label }}</label> -->
          <input 
            type="tel"
            [(ngModel)]="formData[field.key]"
            [name]="field.key"          
            [placeholder]="field.label"
            mask="(000) 000-0000"
            (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
            [required]="field.validations?.required"
            #inputField="ngModel"

          >          
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">            
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">{{ field.label }} is required</small>
            <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
            <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
          </div>             
        </div>  
        <!-- Checkbox de términos -->
        <div *ngIf="field.type === 'checkbox'" class="checkbox-group">
          <label>
            <input 
              type="checkbox"
              [checked]="formData[field.key]?.includes('accepted')"
              (change)="onCheckboxChange(field.key, 'accepted', $event)"
            >
            <span class="disclaimer" [innerHTML]="field.options[0].label"></span>
          </label>
        </div>
      </div>
    </div>
    <!-- Step: Personal Info v2 -->
    <div *ngSwitchCase="'personal_info_v2'" class="contact-form">
      <div *ngFor="let field of step?.fields?.configuration?.fields" [ngClass]="{'form-item-med' : field.settings.inputSize == 'Medium', 'form-item-large' : field.settings.inputSize == 'Large'}">           
        <!-- Text Inputs -->     
        <div *ngIf="field.type === 'text_input'" class="input-group">    
          <span *ngIf="field.label" class="input-label-personal-info" [ngClass]="{'required' : field.validations?.required == true }" > {{field.label}} </span>
          <i class="fa-solid" *ngIf="field.icon" [ngClass]="field.icon" aria-hidden="true"></i>
          <input 
            [placeholder]="field.label"
            [type]="field.type === 'email_input' ? 'email' : 'text'"
            [(ngModel)]="formData[field.key]"
            (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
            [name]="field.key"
            [required]="field.validations?.required"
            (keydown.enter)="false"
            #inputField="ngModel"
            [ngClass]="{'error-required': (inputField.invalid && (inputField.dirty || inputField.touched)) && inputField.errors?.['required'] }"
          >
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">            
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">{{ field.label }} is required</small>
            <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
            <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
          </div>  
        </div>
        <!-- Email Input -->
        <div *ngIf="field.type === 'email_input'" class="input-group">
          <span *ngIf="field.label" class="input-label-personal-info" [ngClass]="{'required' : field.validations?.required == true }" > {{field.label}} </span>
          <i class="fa-solid" *ngIf="field.icon" [ngClass]="field.icon" aria-hidden="true"></i>
          <input 
            [placeholder]="field.label"
            type="email"
            [(ngModel)]="formData[field.key]"
            (ngModelChange)="dataChanged.emit(); onFieldModelChange(field, formData[field.key])"
            [name]="field.key"
            [required]="field.validations?.required"
            (keydown.enter)="$event.preventDefault(); validateEmailFormatOnChange($event, field.key, inputField)"
            (change)="validateEmailFormatOnChange($event, field.key,inputField )"
            #inputField="ngModel"
            [ngClass]="{
                'error-required': (inputField.invalid && (inputField.dirty || inputField.touched)) && inputField.errors?.['required'] || (inputField.invalid && (inputField.dirty || inputField.touched)) && (!(inputField.errors?.['required']) && inputField.errors?.['invalidEmail']) 
                }"
          >
          
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)" class="error-messages">
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">
              {{ field.label }} is required.
            </small>
            <small class="error-required-label" *ngIf="!(inputField.errors?.['required']) && inputField.errors?.['invalidEmail']" >
              Please enter a valid Email Address.
            </small>
          </div>
        </div>
        <!-- Phone Input -->   
        <div *ngIf="field.type === 'phone_input'" class="input-group">
          <span *ngIf="field.label" class="input-label-personal-info" [ngClass]="{'required' : field.validations?.required == true }" > {{field.label}} </span>
          <i class="fa-solid" *ngIf="field.icon" [ngClass]="field.icon" aria-hidden="true"></i>
          <input 
            [placeholder]="field.label"
            type="tel"
            [(ngModel)]="formData[field.key]"
            (keypress)="onlyNumbers($event);"
            (keydown.enter)="$event.preventDefault(); validatePhoneNumber($event, field.key, inputField)"            
            (change)="validatePhoneNumber($event, field.key,inputField )"
            [name]="field.key"
            [required]="field.validations?.required"
            #inputField="ngModel"
            maxlength="10"
          >          
          <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)" class="error-messages">
            <small class="error-required-label" *ngIf="inputField.errors?.['required']">
              {{ field.label }} is required.
            </small>
            <small class="error-required-label" *ngIf="!(inputField.errors?.['required']) && inputField.errors?.['invalidLength']" >
              Please enter a valid Phone Number.
            </small>
          </div>     
        </div>        
        <!-- Checkbox de términos -->
        <div *ngIf="field.type === 'checkbox'" class="checkbox-group">
          <label class="checkbox-label">
            <input 
              type="checkbox"         
              [(ngModel)]="formData[field.key]"
              [name]="field.key"
              [required]="field.validations?.required"
              #inputField="ngModel"
               />
            <span class="checkbox-disclaimer" [innerHTML]="field.content"></span>
          </label>
        </div>
        <!-- Disclosure Jornaya -->
        <div *ngIf="field.type === 'disclosure_jornaya'" class="checkbox-group">
          <div id="disclaimer2" class="disclaimer">
            <span class="conditions">
                <input type="hidden" id="leadid_tcpa_disclosure" autocomplete="off">
                <label id="tcpaDisclosureContent" [innerHTML]="field.content ? (field.content | interpolate: getInterpolationData()) : ''"></label>
                <div id="srDisclosure" *ngIf="!field.content"></div>
            </span>
          </div>
        </div>        
      </div>
    </div>
    <!-- Step: Dynamic -->
    <div *ngSwitchCase="'dynamic'" class="slider-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields" class="slider-container">
        <div class="dynamic-loader-bar">
          <div class="loader-bar" id="loader-bar"></div>
        </div>
        <label *ngIf="field.label">{{ field.label }}</label>
      </div>
    </div>
    <div *ngSwitchCase="'multiple_types'" class="mutiple-types-group">
      <div *ngFor="let field of step?.fields?.configuration?.fields" class="field-for-container">
        <div [ngSwitch]="field.settings?.type" class="field-type-container">
          <div *ngSwitchCase="'slider_input'" class="slider-group" [id] ="field.key">
              <label *ngIf="field.label" [innerHTML]="field.label | interpolate: getInterpolationData()" >{{ field.label }}</label>  
              <div *ngIf="field.toolTip" class="tooltip-container" [innerHTML]="field.toolTip | interpolate: getInterpolationData()"></div> 
              <input 
                  [id]="field.key"
                  class="custom_salider"
                  type="range" 
                  [(ngModel)]="formData[field.key]" 
                  (ngModelChange)="dataChanged.emit()"
                  [required]="field.validations?.required"
                  [name]="field.key"  
                  [min]="field.validations?.min"
                  [max]="field.validations?.max"
                  [max]="field.validations?.dynamicMax != null ? getInterpolationData()[field.validations?.dynamicMax] : field.validations?.max"
                  [step]="field.sliderStep" 
                  #inputField="ngModel">
              <div class="appearance-container">
                <div class="appearance-range" *ngIf="field.settings?.appearance == 'range'">
                  <div *ngIf="field.settings?.valueType == 'currency'">
                    <div *ngIf="field.validations?.plusvalue">
                      <div *ngIf="formData[field.key] < field.validations?.max">
                        <label for="" class="label-question">{{ (formData[field.key] - 10000) | currency:'USD':'symbol':'1.0-0'  }} - {{ (formData[field.key] + 10000) | currency:'USD':'symbol':'1.0-0'  }}</label>
                      </div>
                      <div *ngIf="formData[field.key] == field.validations?.max">
                        <label for="" class="label-question">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0') + "+"   }}</label>
                      </div>
                    </div>
                    <div *ngIf="!field.validations?.plusvalue">
                      <div *ngIf="formData[field.key] == 0">
                        <label for="" class="label-question">{{ (formData[field.key]) | currency:'USD':'symbol':'1.0-0' }}</label>
                      </div>
                      <div *ngIf="formData[field.key] != 0">
                        <label for="" class="label-question">{{ (formData[field.key] - 10000) | currency:'USD':'symbol':'1.0-0'  }} - {{ (formData[field.key] + 10000) | currency:'USD':'symbol':'1.0-0' }}</label>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="field.settings?.valueType == 'percentage'">
                    <div *ngIf="field.validations?.minusvalue">
                      <div *ngIf="formData[field.key] == field.validations?.min">
                        <label for="" class="label-question">{{ (formData[field.key] + 1 ) + "% or Lower" }}</label>                
                      </div>
                    </div>              
                    <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
                      <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                    </div>
                    <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
                      <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                        <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' )  + "%" }}</label>
                      </div>
                    </div> 
                    <div *ngIf="field.validations?.plusvalue">
                      <!-- <div *ngIf="(formData[field.key] < field.validations?.max) && !(formData[field.key] == field.validations?.min)">
                        <label for="">{{ (formData[field.key] | number: '1.2-2' ) + "%" }}</label>
                      </div> -->
                      <div *ngIf="formData[field.key] == field.validations?.max">
                        <label for="" class="label-question">{{ "Over " + (formData[field.key] - 1 ) + "%" }}</label>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
                    <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
                    <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
                    <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
                  </div>  
                </div>
                <div *ngIf="field.settings?.appearance != 'range'">
                  <div *ngIf="field.settings?.valueType == 'currency'">
                    <div *ngIf="field.validations?.plusvalue">
                      <div *ngIf="formData[field.key] < field.validations?.max">
                        <!-- <label for="" class="label-question">{{ formData[field.key] | currency:'USD' : 'symbol' : '1.0-0'  }}</label> -->
                        <label for="" class="label-question">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0'  }}</label>
                      </div>
                      <div *ngIf="formData[field.key] == field.validations?.max">
                        <label for="" class="label-question">{{ (formData[field.key] - 1 | currency:'USD':'symbol':'1.0-0') + "+"   }}</label>
                      </div>
                    </div>
                    <div *ngIf="!field.validations?.plusvalue">
                      <label for="" class="label-question">{{ formData[field.key] | currency:'USD':'symbol':'1.0-0' }}</label>
                    </div>
                  </div>
                  <div *ngIf="field.settings?.valueType == 'percentage'">
                    <div *ngIf="field.validations?.minusvalue">
                      <div *ngIf="formData[field.key] == field.validations?.min">
                        <label for="" class="label-question">{{ (formData[field.key] + 1 ) }}<span>% or Lower</span></label>                
                      </div>
                    </div>              
                    <div *ngIf="!field.validations?.plusvalue && !field.validations?.minusvalue">
                      <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' ) }}<span>%</span></label>
                    </div>
                    <div *ngIf="field.validations?.plusvalue || field.validations?.minusvalue">
                      <div *ngIf="!(formData[field.key] == field.validations?.min) && !(formData[field.key] == field.validations?.max)">
                        <label for="" class="label-question">{{ (formData[field.key] | number: '1.2-2' ) }}<span>%</span></label>
                      </div>
                    </div> 
                    <div *ngIf="field.validations?.plusvalue">
                      <div *ngIf="formData[field.key] == field.validations?.max">
                        <label for="" class="label-question">{{ "Over " + (formData[field.key] - 1 ) }}<span>%</span></label>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="inputField.invalid && (inputField.dirty || inputField.touched)">
                    <small class="error" *ngIf="inputField.errors?.['required']">Campo requerido</small>
                    <small class="error" *ngIf="inputField.errors?.['min']">Mínimo: {{ field.validations.min }}</small>
                    <small class="error" *ngIf="inputField.errors?.['max']">Máximo: {{ field.validations.max }}</small>
                  </div>  
                </div>
            </div> 
          </div>
          <div *ngSwitchCase="'single_option'" class="single-option-group">
            <div class="card-select-container">
              <div *ngFor="let field of step?.fields?.configuration?.fields" class="card-grid" [id] ="field.key">
                <label *ngIf="field.settings?.type == 'single_option' && field.label" [innerHTML]="field.label | interpolate: getInterpolationData()" >{{ field.label }}</label>  
                <div *ngFor="let option of field.options" class="property-card"     
                      [ngClass]="{'selected' : formData[field.key] == option.value }" 
                      [id]="option.value" 
                      (click)="selectOptionDynamic(field.key, option, $event, field.selectAction);">            
                  <!-- <span>{{ option.label }}</span> -->
                  <div  [innerHTML]="option.label"></div>
                </div>
              </div>
            </div>
          </div>          
        </div>    
      </div>  
  </div>
  <div *ngIf="step?.fields?.stepSubTitle"></div>
</div>
